import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import { ArrowRight, Zap, Shield, Clock, Phone, Wifi, WifiOff, Users, BarChart3, CheckCircle, Search, Cpu, Server } from "lucide-react"

const AssessmentIntro = ({ onStart, onEmergencyAssessment }) => {
  const features = [
    {
      icon: 'Zap',
      title: 'Quick & Comprehensive',
      description: 'Complete assessment in 8-12 minutes with detailed analysis'
    },
    {
      icon: 'Shield',
      title: 'Secure & Confidential',
      description: 'Your network information is protected and never shared'
    },
    {
      icon: 'TrendingUp',
      title: 'ROI Calculations',
      description: 'Get projected returns on fiber infrastructure investment'
    },
    {
      icon: 'Users',
      title: 'Expert Recommendations',
      description: 'Receive personalized solutions from certified specialists'
    }
  ];

   const supportFeatures = [
    {
      title: "Fast Diagnostics",
      description: "Quick identification of issues to minimize downtime",
      icon: <Search className="w-8 h-8" />,
    },
    {
      title: "Efficient Solutions",
      description: "Practical fixes without technical jargon",
      icon: <CheckCircle className="w-8 h-8" />,
    },
    {
      title: "Long-Term Fixes",
      description: "Resolutions that prevent recurring issues",
      icon: <Shield className="w-8 h-8" />,
    },
    {
      title: "End-to-End Support",
      description: "Comprehensive assistance from detection to resolution",
      icon: <Users className="w-8 h-8" />,
    },
    {
      title: "Root-Cause Analysis",
      description: "Identifying underlying issues, not just symptoms",
      icon: <BarChart3 className="w-8 h-8" />,
    },
    {
      title: "Quick On-Site Visits",
      description: "When necessary, we come to you for hands-on solutions",
      icon: <Phone className="w-8 h-8" />,
    },
  ]
  const benefits = [
    'Identify network performance bottlenecks',
    'Discover security vulnerabilities',
    'Calculate potential cost savings',
    'Plan for future growth requirements',
    'Compare fiber vs. copper performance',
    'Get preliminary project timeline'
  ];

  return (
    <div className="space-y-8">
      {/* Hero Section */}
      <div className="rounded-lg  p-8 text-center">
        <div className="mb-6 text-center">
  <div className="flex items-center justify-center gap-3 mb-2">
    <div className="flex items-center justify-center w-12 h-12 bg-primary/10 rounded-full">
      <Icon name="Hammer" size={64} className="text-primary" />
    </div>
    <h1 className="text-3xl font-bold text-text-primary">
      Technical Support
    </h1>
  </div>
  <p className="text-lg text-text-secondary max-w-2xl mx-auto leading-relaxed">
    Expert solutions when your fiber optic internet needs attention
  </p>
</div>

        
        {/* <div className="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-4">
          <Button
            variant="default"
            size="lg"
            onClick={onStart}
            iconName="Play"
            iconPosition="left"
            className="cta-primary"
          >
            Start Assessment
          </Button>
          <Button
            variant="outline"
            size="lg"
            onClick={onEmergencyAssessment}
            iconName="AlertTriangle"
            iconPosition="left"
            className="trust-glow"
          >
            Emergency Assessment
          </Button>
        </div> */}
      </div>
      {/* Features Grid */}
      {/* <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {features?.map((feature, index) => (
          <div key={index} className="bg-white rounded-lg shadow-brand-subtle p-6 text-center micro-bounce">
            <div className="inline-flex items-center justify-center w-12 h-12 bg-primary/10 rounded-full mb-4">
              <Icon name={feature?.icon} size={24} className="text-primary" />
            </div>
            <h3 className="text-lg font-semibold text-text-primary mb-2">{feature?.title}</h3>
            <p className="text-sm text-text-secondary">{feature?.description}</p>
          </div>
        ))}
      </div> */}
      {/* What You'll Discover */}
      <div className="bg-slate-50 rounded-lg shadow-brand-moderate p-8">
        <div className="gap-8 items-center">

             
            <div className="flex items-center gap-8">
              <div className="flex-1">
                
                <p className="text-lg mx-auto leading-relaxed mb-6">
                  STOP. Before you go into full-blown panic mode because your fiber optic internet has just cut out, you need to know one thing: You're not alone.
                </p>
                <p className="text-lg text-gray-500 mx-auto leading-relaxed mb-8">
                  Everyone has had that terrifying moment when the Wi-Fi disappears, and suddenly life feels like it's on pause. 
                  But before you start calling your ISP and venting your frustrations, just know this: Our technical support 
                  team can fix this in no time. Whether it’s a random glitch, an outage, or an installation issue, we’re on it. Keep reading to find out how we’ll have you cruising the web again – smoothly, swiftly, and with minimal hassle.
                </p>
              </div>
              <div className="justify-center">
                <div className="relative">
                  <div className="absolute inset-0 bg-blue-500/20 rounded-full blur-xl animate-pulse"></div>
                  <div className="relative border border-blue-500/30 rounded-2xl p-8">
                    <Wifi className="w-24 h-24 text-blue-400 mx-auto mb-4" />
                    <div className="text-center">
                      <p className="text-black font-semibold">Connection Status</p>
                      <p className="text-green-400">Optimal Performance</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
         
         
          
          {/* <div className="relative">
            <div className="bg-surface rounded-lg p-6 precision-grid">
              <div className="space-y-4">
                <div className="flex items-center justify-between p-3 bg-white rounded border">
                  <span className="text-sm font-medium">Current Speed</span>
                  <span className="text-sm text-error">25 Mbps</span>
                </div>
                <div className="flex items-center justify-between p-3 bg-white rounded border">
                  <span className="text-sm font-medium">Fiber Potential</span>
                  <span className="text-sm text-success">1 Gbps</span>
                </div>
                <div className="flex items-center justify-between p-3 bg-white rounded border">
                  <span className="text-sm font-medium">Performance Gain</span>
                  <span className="text-sm text-primary">4000%</span>
                </div>
                <div className="flex items-center justify-between p-3 bg-white rounded border">
                  <span className="text-sm font-medium">ROI Timeline</span>
                  <span className="text-sm text-accent">18 months</span>
                </div>
              </div>
            </div>
          </div> */}
        </div>
      </div>
      {/* Assessment Process */}
      <div className="bg-white rounded-lg shadow-brand-moderate p-8">
        <h2 className="text-3xl sm:text-4xl font-bold text-black mb-8 text-center">A Fiber Glitch Gone Right (And How We Handled It)</h2>
          <div className="bg-white p-2 backdrop-blur-sm">
            <p className="text-lg text-gray-500 mx-auto leading-relaxed mb-6">
              A few months ago, someone was deep into an important Zoom call. The stakes? High. The client? Extremely picky. The conversation? Crucial. 
            </p>
            <p className="text-lg text-gray-500 mx-auto leading-relaxed mb-6">
              But of course, right in the middle of it, the internet decided it was going to have a meltdown. Was it the router? The Wi-Fi signal? Maybe a squirrel had chewed through the cables again? Who knows.
            </p>
            <p className="ttext-lg text-gray-500 mx-auto leading-relaxed mb-6">
              In a flurry of panic, they contacted our support team. After all, fiber optics are supposed to be fast, reliable, and almost too good to be true. So what's the deal when it suddenly decides to fail?
            </p>
            <div className="bg-slate-50 border border-blue-500/30 rounded-xl p-6 mt-8">
              <h3 className="text-lg text-gray-500 mx-auto leading-relaxed mb-4 flex items-center">
                <Zap className="mr-2 text-yellow-400" />
                Here's what happened next:
              </h3>
              <ul className="space-y-3">
                <li className="flex items-center text-gray-600">
                  <div className="w-2 h-2 bg-blue-500 rounded-full mr-3"></div>
                  Our support team responded within 3 minutes
                </li>
                <li className="flex items-center text-gray-600">
                  <div className="w-2 h-2 bg-blue-500 rounded-full mr-3"></div>
                  We identified the issue as a temporary signal disruption
                </li>
                <li className="flex items-center text-gray-600">
                  <div className="w-2 h-2 bg-blue-500 rounded-full mr-3"></div>
                  Guided a quick router reset remotely
                </li>
                <li className="flex items-center text-gray-600">
                  <div className="w-2 h-2 bg-blue-500 rounded-full mr-3"></div>
                  Full connection restored in under 8 minutes
                </li>
                <li className="flex items-center text-gray-600">
                  <div className="w-2 h-2 bg-blue-500 rounded-full mr-3"></div>
                  The Zoom call continued with no further issues
                </li>
              </ul>
            </div>
          </div>
        {/* <h2 className="text-2xl font-semibold text-text-primary mb-6 text-center">
          Simple 5-Step Process
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-5 gap-6">
          {[
            { step: 1, title: 'Network Overview', icon: 'Network', description: 'Current setup and issues' },
            { step: 2, title: 'Infrastructure Details', icon: 'Server', description: 'Hardware and connections' },
            { step: 3, title: 'Performance Requirements', icon: 'Gauge', description: 'Speed and reliability needs' },
            { step: 4, title: 'Future Planning', icon: 'Calendar', description: 'Growth and expansion plans' },
            { step: 5, title: 'Results & Recommendations', icon: 'FileText', description: 'Detailed analysis report' }
          ]?.map((step, index) => (
            <div key={index} className="text-center">
              <div className="relative mb-4">
                <div className="inline-flex items-center justify-center w-12 h-12 bg-primary rounded-full text-white font-semibold">
                  {step?.step}
                </div>
                {index < 4 && (
                  <div className="hidden md:block absolute top-6 left-full w-full h-0.5 bg-border -translate-y-0.5" />
                )}
              </div>
              <div className="mb-2">
                <Icon name={step?.icon} size={20} className="text-primary mx-auto mb-2" />
                <h3 className="font-semibold text-text-primary text-sm">{step?.title}</h3>
              </div>
              <p className="text-xs text-text-secondary">{step?.description}</p>
            </div>
          ))}
        </div> */}
      </div>
      {/* Trust Indicators */}
      <div className="relative z-10 bg-slate-50 rounded-lg shadow-brand-moderate p-8">
            <div className="text-center mb-12">
              <h2 className="text-3xl sm:text-4xl font-bold text-black mb-4">Stay Chill: Fiber Optic Issues Can Be Quickly Resolved</h2>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                It's easy to assume that when fiber optics mess up, it's a catastrophic event. But the truth is, these issues happen all the time.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cos-2 gap-8">
              <div>
                <div className="flex items-start mb-6">
                  <div className="bg-green-500/10 p-3 rounded-lg mr-4">
                    <WifiOff className="w-8 h-8 text-green-400" />
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold text-black mb-2">Common Issues We Fix</h3>
                    <p className="text-gray-600">Fiber optic internet is high-speed, but it's still a system that depends on a lot of moving parts.</p>
                  </div>
                </div>
                <ul className="space-y-3">
                  <li className="flex items-center text-gray-600">
                    <div className="w-2 h-2 bg-green-500 rounded-full mr-3"></div>
                    Loose connections or faulty terminations
                  </li>
                  <li className="flex items-center text-gray-600">
                    <div className="w-2 h-2 bg-green-500 rounded-full mr-3"></div>
                    Signal degradation over long distances
                  </li>
                  <li className="flex items-center text-gray-600">
                    <div className="w-2 h-2 bg-green-500 rounded-full mr-3"></div>
                    Equipment malfunctions or failures
                  </li>
                  <li className="flex items-center text-gray-600">
                    <div className="w-2 h-2 bg-green-500 rounded-full mr-3"></div>
                    Network congestion during peak hours
                  </li>
                  <li className="flex items-center text-gray-600">
                    <div className="w-2 h-2 bg-green-500 rounded-full mr-3"></div>
                    Environmental factors affecting cables
                  </li>
                </ul>
              </div>

              <div>
                <div className="flex items-start mb-6">
                  <div className="bg-blue-500/10 p-3 rounded-lg mr-4">
                    <Shield className="w-8 h-8 text-blue-400" />
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold text-black mb-2">Our Approach</h3>
                    <p className="text-gray-600">We're all about practical, simple solutions. No tech mumbo jumbo.</p>
                  </div>
                </div>
                <ul className="space-y-3">
                  <li className="flex items-center text-gray-600">
                    <div className="w-2 h-2 bg-blue-500 rounded-full mr-3"></div>
                    Pinpoint the issue with advanced diagnostics
                  </li>
                  <li className="flex items-center text-gray-600">
                    <div className="w-2 h-2 bg-blue-500 rounded-full mr-3"></div>
                    Explain the problem in simple, understandable terms
                  </li>
                  <li className="flex items-center text-gray-600">
                    <div className="w-2 h-2 bg-blue-500 rounded-full mr-3"></div>
                    Implement the most efficient solution
                  </li>
                  <li className="flex items-center text-gray-600">
                    <div className="w-2 h-2 bg-blue-500 rounded-full mr-3"></div>
                    Verify the fix and ensure stability
                  </li>
                  <li className="flex items-center text-gray-600">
                    <div className="w-2 h-2 bg-blue-500 rounded-full mr-3"></div>
                    Provide tips to prevent future occurrences
                  </li>
                </ul>
              </div>
            </div>
          </div>

<div className='text-center mb-12 bg-white rounded-lg shadow-brand-moderate p-8'>
<div className="text-center mb-12 ">
            <h2 className="text-3xl sm:text-4xl font-bold text-black mb-4 pt-4">What Makes Our Technical Support Team Stand Out?</h2>
            <p className="text-xl text-gray-600">You could call us the "tech troubleshooters." When something goes wrong, we're here to save the day.</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {supportFeatures.map((feature, index) => (
             <div className='bg-gray-300/50 border border-gray-700/50 rounded-2xl p-6 backdrop-blur-sm'>
                <div className="text-blue-400 mb-4">{feature.icon}</div>
                <h3 className="text-lg font-semibold text-black mb-2">{feature.title}</h3>
                <p className="text-gray-600">{feature.description}</p>
                </div>
            ))}
          </div>
          </div>
      <div className="bg-slate-50 rounded-lg shadow-brand-moderate p-8">
        <div className="text-center mb-6">
          <h2 className="text-xl font-semibold text-text-primary mb-2">
            Trusted by 500+ Businesses
          </h2>
          <p className="text-text-secondary">
            Join companies that have transformed their infrastructure with our expertise
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="text-center p-4 bg-surface rounded-lg">
            <div className="text-2xl font-bold text-primary">98%</div>
            <div className="text-sm text-text-secondary">Client Satisfaction</div>
          </div>
          <div className="text-center p-4 bg-surface rounded-lg">
            <div className="text-2xl font-bold text-success">24/7</div>
            <div className="text-sm text-text-secondary">Emergency Support</div>
          </div>
          <div className="text-center p-4 bg-surface rounded-lg">
            <div className="text-2xl font-bold text-accent">15+ Years</div>
            <div className="text-sm text-text-secondary">Industry Experience</div>
          </div>
        </div>
      </div>      
    </div>
  );
};

export default AssessmentIntro;